import React from "react";
import { styled } from "styled-components";

const LoginPage = () => {
  return <div className="LoginPage">로그인페이지</div>;
};

export default LoginPage;
